function position_announcements() {
    const announcements = document.querySelector('.am-announcements-container');
    if (!announcements) {
        return;
    }
    const header = announcements.querySelector('.am-announcements-header');
    const listContainer = announcements.querySelector('.am-announcement-list-container');

    const headerHeight = header.getBoundingClientRect().height;
    const announcementsPadding = parseInt(announcements.getStyle('padding-top')) + parseInt(announcements.getStyle('padding-bottom'));
    const announcementsHeight = announcements.getBoundingClientRect().height;

    if (is_mobile_or_tablet()) {
        const maxHeight = announcementsHeight - announcementsPadding - headerHeight;
        if (maxHeight > 0) {
            listContainer.style.maxHeight = maxHeight + 'px';
        }
        const container = document.querySelector('.am-toolbar-header .dropdown-announcements');
        if (!container.contains(announcements)) {
            container.append(announcements);
        }
    } else {
        listContainer.style.maxHeight = '';
        const container = document.querySelector('.offcanvas-body .dropdown-announcements');
        if (!container.contains(announcements)) {
            container.append(announcements);
        }
    }
}

function position_appcues() {
    const appcuesLi = document.querySelector('#appcues-widget');
    if (!appcuesLi) {
        return true;
    }
    const icon = appcuesLi.querySelector('[data-appcues-icon]');
    const badge = appcuesLi.querySelector('[data-appcues-badge]');
    const appcuesButton = appcuesLi.querySelector('#appcues-widget-icon');
    const link = appcuesLi.querySelector('.nav-link');
    let buttonUpdated = false;
    let attempts = 1;

    if (icon && appcuesButton && badge) {
        link.style.display = 'none';

        icon.removeAttribute('data-appcues-icon');
        badge.removeAttribute('data-appcues-badge');
        appcuesButton.append(icon);
        // pass tooltip properties to new button
        appcuesButton.dataset.bsToggle = link.dataset.bsToggle;
        appcuesButton.dataset.bsPlacement = link.dataset.bsPlacement;
        appcuesButton.dataset.bsTitle = link.dataset.bsTitle;
        appcuesButton.dataset.bsContainer = link.dataset.bsContainer;

        appcuesLi.append(badge);

        let badgeAttempts = 0;
        const countInterval = setInterval(() => {
            const appCuesCount = appcuesButton.dataset.appcuesCount;
            badge.textContent = appCuesCount;
            badge.style.display = appCuesCount > 0 ? 'block' : 'none';
            badgeAttempts++;
            if (badgeAttempts === 5) {
                clearInterval(countInterval);
            }
        }, 1000);

        buttonUpdated = true;
    } else {
        if (appcuesLi.dataset.attempts) {
            attempts = parseInt(appcuesLi.dataset.attempts);
        }

        if (attempts >= 5) {
            if (!appcuesButton) {
                link.style.display = 'inline-flex';
            }
            buttonUpdated = true;
        }

        attempts++;
        appcuesLi.dataset.attempts = attempts.toString();
    }

    if (is_mobile_or_tablet()) {
        const container = document.querySelector('.am-toolbar-header');
        const announcementsLi = container.querySelector('.dropdown-announcements');
        const ul = announcementsLi.parentElement;

        if (!ul.contains(appcuesLi)) {
            ul.append(appcuesLi);
        }
    } else {
        const announcementLi = document.querySelector('.offcanvas-body .dropdown-announcements');
        announcementLi.parentElement.insertBefore(appcuesLi, announcementLi.nextSibling);
    }

    return buttonUpdated;
}

function position_quickfind() {
    const form = document.querySelector('form.quickfind');
    if (!form) {
        return;
    }
    if (is_mobile_or_tablet()) {
        const container = document.querySelector('.am-toolbar-header');
        const searchLi = container.querySelector('.nav-search-item');
        const menuList = searchLi.parentElement;

        if (!container.contains(form)) {
            form.classList.remove('results-open');
            searchLi.append(form);
        }

        if (is_mobile()) {
            if (menuList.lastElementChild !== searchLi) {
                menuList.appendChild(searchLi);
            }
        } else {
            if (menuList.firstElementChild !== searchLi) {
                menuList.prepend(searchLi);
            }
        }
    } else {
        document.querySelector('.am-toolbar-header .nav-search-item').classList.remove('open');
        const container = document.querySelector('.offcanvas-body .nav-search-item');
        if (!container.contains(form)) {
            form.classList.remove('results-open');
            container.append(form);
        }
    }
}

function openLoginDropdown() {
    if (is_mobile_or_tablet()) {
        return;
    }
    var userIdEl = document.getElementById('user-id');
    if (!userIdEl || !userIdEl.value) {
        const login_dropdown = document.querySelector('.dropdown-login');

        if (!login_dropdown) {
            return;
        }

        const dropdownTrigger = login_dropdown.previousElementSibling;

        if (!dropdownTrigger) {
            return;
        }

        const dropdown = bootstrap.Dropdown.getOrCreateInstance(dropdownTrigger);

        dropdown?.show();
    }
}

function matchUrlWithNavMenu() {
    const currentPath = location.origin + location.pathname;

    document.querySelectorAll('.am-toolbar .nav-link, .am-toolbar .dropdown-item').forEach(/**@param link {HTMLLinkElement}*/link => {
        if (link.dataset.excludeFromUrlMatch === "true" || link.classList.contains('disabled')) {
            return;
        }
        let linkHref = link.href;
        const isHome = linkHref.endsWith('/home/') && currentPath.startsWith(linkHref);

        if (!linkHref.endsWith('/')) {
            linkHref += '/';
        }

        if (linkHref === currentPath || isHome) {
            const dropdown = link.closest('.dropdown');
            if (dropdown?.dataset.excludeFromUrlMatch === 'true') {
                return;
            }

            link.classList.add('active');

            if (dropdown && !dropdown.querySelector('.nav-profile-link')) { // we don't want to mark the profile picture as active.
                // dropdown.querySelector('.nav-link')?.classList.add('active'); // dont show dropdown toggle as active

                // to show the user on the current selection
                if (is_mobile_or_tablet()) {
                    const dropdownHeader = link.closest('.dropdown-menu-inner')?.querySelector('.dropdown-header');
                    dropdown.querySelector('.dropdown-toggle')?.click();
                    setTimeout(() => {
                        dropdownHeader?.click();
                    }, 500);
                }
            }
        }
    });
}

function positionDropdownMenuOnDesktopOverflow(dropdownMenu) {
    if (!is_mobile_or_tablet()) {
        const rect = dropdownMenu.getBoundingClientRect();
        if (rect.right > window.innerWidth) {
            dropdownMenu.style.left = window.innerWidth - rect.right - 20 + 'px';
        }
    } else {
        dropdownMenu.style.left = '';
    }
}

function collapse_navbar_offcanvas() {
    bootstrap.Offcanvas.getOrCreateInstance('#navbar-allmoxy')?.hide();
}

am.$(() => {
    const navbar_backdrop = document.querySelector('.offcanvas-menu-backdrop');
    const link_trigger = document.querySelectorAll('.am-toolbar .nav-link.dropdown-toggle, .am-toolbar .dropdown-menu-inner .dropdown-header');
    const button_back = document.querySelector('.button-back');
    let current_menu = [];
    const offcanvasElement = document.querySelector('.offcanvas');
    const offcanvas = offcanvasElement ? bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement) : null;

    link_trigger.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            const is_inner = e.currentTarget.classList.contains('dropdown-header');
            const li = is_inner ? e.currentTarget.closest('.dropdown-menu-inner') : e.target.closest('.nav-item.dropdown');

            if (li.classList.contains('expanded-nav') || !is_mobile_or_tablet()) {
                return;
            }

            current_menu.push(li);
            navbar_backdrop.style.zIndex = current_menu.length;
            navbar_backdrop.classList.add('show');
            button_back.style.opacity = 1;
            li.style.translate = '-100%';
            setTimeout(() => {
                li.classList.add('expanded-nav');

                if (li.classList.contains('expanded-nav')) {
                    setTimeout(() => {
                        li.style.translate = '';
                        li.classList.add('show');
                    }, 100);
                }
                setTimeout(() => {
                    navbar_backdrop.style.zIndex = 1;
                }, 350);
            }, 100);
        });
    });

    button_back?.addEventListener('click', ev => {
        if (current_menu.length === 0) {
            offcanvas?.hide();
            return;
        }

        const li = current_menu.pop();
        li.classList.remove('show');
        setTimeout(() => {
            li.classList.remove('expanded-nav');
            navbar_backdrop.classList.remove('show');
            if (current_menu.length === 0 && is_mobile()) {
                button_back.style.opacity = 0;
            }
        }, 100);

    });

    am.$('.btn-search-open').click((e) => {
        e.preventDefault();
        const $btn = am.$(e.currentTarget);
        const $form = am.$('form.quickfind');
        const $container = $btn.parent();

        $container.append($form);

        setTimeout(() => {
            $container.addClass('open');
        }, 100);
    });

    am.$('.search-close').click((e) => {
        e.preventDefault();
        const $btn = am.$(e.currentTarget);
        $btn.closest('.nav-search-item').removeClass('open');
    });

    position_announcements();
    matchUrlWithNavMenu();

    let appcuesTicks = 0;
    const appcuesInterval = setInterval(() => {
        appcuesTicks++;
        if (position_appcues() || appcuesTicks >= 20) {
            clearInterval(appcuesInterval);
            position_quickfind();
        }
    }, 100);

    window.addEventListener('resize', () => {
        position_announcements();
        setTimeout(() => {
            position_announcements();
        }, 500);
        position_appcues();
        position_quickfind();
        if (button_back) {
            //hide back button only on mobile if is the home menu
            button_back.style.opacity = is_tablet() ? 1 : (current_menu.length === 0 ? 0 : 1);
        }
    });

    let idleTimer;
    function resetIdleTimer() {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function() {
            show_announcement_annimation();
        }, 5000);
    }

    //there are two announcements dropdown but they work like one
    document.querySelectorAll('.dropdown-announcements').forEach(dropdown => {
        dropdown.addEventListener('mouseover', ev => {
            const tooltip = bootstrap.Tooltip.getOrCreateInstance(dropdown);
            const dropdownMenu = dropdown.querySelector('.dropdown-menu');

            if (dropdownMenu?.classList.contains('show')) {
                tooltip?.hide();
                tooltip?.disable();
            } else {
                tooltip?.enable();
            }
        });
        dropdown.addEventListener('show.bs.dropdown', event => {
            position_announcements();
            load_announcements(false, false);
            am.$('#js-load-more-announcements').attr('loadcount', '');
        });
        dropdown.addEventListener('shown.bs.dropdown', event => {
            setTimeout(() => {
                position_announcements();
            }, 500);

            const tooltip = bootstrap.Tooltip.getOrCreateInstance(dropdown);
            tooltip?.hide();
            tooltip?.disable();

            if (is_mobile_or_tablet()){
                resetIdleTimer();
            }
        });
        dropdown.addEventListener('hidden.bs.dropdown', event => {
            const tooltip = bootstrap.Tooltip.getOrCreateInstance(dropdown);
            tooltip?.enable();

            if (is_mobile_or_tablet()){
                clearTimeout(idleTimer);
                show_announcement_annimation(true);
                am.$('.am-announcement-list').removeAttr('data-slide-shown');
            }
        });
        if (is_mobile_or_tablet()){
            var li = dropdown.querySelector('.am-announcements-container');
            if(li != null){
                li.addEventListener('touchend', event => {
                    clearTimeout(idleTimer);
                    resetIdleTimer()
                });
            }
        }
    });

    let lastOpenedDropdown = null;

    // Event-driven dropdown close logic (replaces 50ms polling setInterval)
    function tryCloseDropdown(element) {
        if (!element) return;
        if (element.getAttribute('data-bs-open-hover') === 'false') return;

        if (element.getAttribute('data-bs-focusable') === 'true') {
            if (element.closest('.dropdown')?.contains(document.activeElement)) return;
        }

        var dropdown = bootstrap.Dropdown.getOrCreateInstance(element);
        if (!is_mobile_or_tablet()) {
            // Every caller means "close this menu now" — the old guard compared the
            // not-yet-reassigned lastOpenedDropdown against itself (and autoClose is
            // the string "outside", never true), so hovering menu B left menu A open.
            element.classList.remove('disabled', 'opening');
            element.closest('.dropdown')?.querySelector('.dropdown-menu')?.classList.remove('complete');
            dropdown?.hide();
        }
    }

    document.querySelectorAll('.am-toolbar .nav-link:not([data-bs-toggle="dropdown"])').forEach(/**@param element {HTMLAnchorElement}*/element => {
        element.addEventListener('mouseenter', ev => {
            if (lastOpenedDropdown?.dataset.interval) {
                clearTimeout(parseInt(lastOpenedDropdown.dataset.interval));
            }
            // to close dropdowns when the mouse is over other non-dropdown menu
            if (lastOpenedDropdown?.dataset.autocloseDelay) {
                element.dataset.outsideTimeout = setTimeout(() => {
                    if (lastOpenedDropdown?.dataset.over !== 'true') {
                        tryCloseDropdown(lastOpenedDropdown);
                        lastOpenedDropdown = null;
                    }
                }, parseInt(lastOpenedDropdown.dataset.autocloseDelay));
            } else if (lastOpenedDropdown) {
                tryCloseDropdown(lastOpenedDropdown);
                lastOpenedDropdown = null;
            }
        });

        element.addEventListener('mouseleave', ev => {
            if (element.dataset.outsideTimeout) {
                clearTimeout(parseInt(element.dataset.outsideTimeout));
                delete element.dataset.outsideTimeout;
            }
        });
    });

    // open dropdowns on hover
    document.querySelectorAll('.am-toolbar [data-bs-toggle="dropdown"]').forEach(/**@param element {HTMLAnchorElement}*/element => {
        element.addEventListener('show.bs.dropdown', ev => {
            element.classList.add('disabled', 'opening'); //to prevent closing the dropdown when is opening
            const dropdownMenu = element.closest('.dropdown').querySelector('.dropdown-menu');
            if (dropdownMenu.dataset.repositionOnOverflow === "true") {
                positionDropdownMenuOnDesktopOverflow(dropdownMenu);
            }
            setTimeout(() => {
                if (dropdownMenu.classList.contains('show')) {
                    dropdownMenu.classList.add('complete');
                    element.classList.remove('disabled', 'opening');
                }
            }, 500);
        });

        element.addEventListener('hide.bs.dropdown', ev => {
            const dropdownMenu = element.closest('.dropdown').querySelector('.dropdown-menu');
            dropdownMenu?.classList.remove('complete');
            element.dataset.open = 'false';
            setTimeout(() => {
                if (element.style.display === 'none') {
                    element.style.display = '';
                }
            }, 0);
        });

        element.addEventListener('mouseleave', ev => {
            element.dataset.over = 'false';
        });

        element.closest('.dropdown').addEventListener('mouseenter', ev => {
            if (element.dataset.interval) {// to prevent autoclosing the dropdown if the mouse is over it
                clearInterval(parseInt(element.dataset.interval));
            }
            // Cancel pending close for THIS element
            if (element.dataset.closeTimeout) {
                clearTimeout(parseInt(element.dataset.closeTimeout));
                delete element.dataset.closeTimeout;
            }
            // Close the previously open dropdown if moving to a different one
            if (lastOpenedDropdown && lastOpenedDropdown !== element) {
                tryCloseDropdown(lastOpenedDropdown);
            }
            element.dataset.over = 'true';
            lastOpenedDropdown = element;

            setTimeout(() => {// We use a delay to not open the dropdown immediately after the cursor is over the menu
                const dropdown = bootstrap.Dropdown.getOrCreateInstance(element);

                if (element.getAttribute('data-bs-open-hover') === 'false') {
                    return;
                }

                if (!is_mobile_or_tablet()) {
                    if (element.dataset.over === 'true') {
                        dropdown?.show();
                        element.dataset.open = 'true';
                    }
                }
            }, 200);
        });

        element.closest('.dropdown').addEventListener('mouseleave', ev => {
            element.dataset.over = 'false';

            // Cancel any previous close timeout for this element
            if (element.dataset.closeTimeout) {
                clearTimeout(parseInt(element.dataset.closeTimeout));
            }

            // Schedule close check after 50ms (matches original polling interval)
            element.dataset.closeTimeout = setTimeout(() => {
                if (element.dataset.over === 'false') {
                    // Clear lastOpenedDropdown BEFORE tryCloseDropdown so the
                    // "lastOpenedDropdown !== element" check passes
                    if (lastOpenedDropdown === element) {
                        lastOpenedDropdown = null;
                    }
                    tryCloseDropdown(element);
                }
            }, 50).toString();
        });
    });

    // Close focusable dropdowns (e.g. login form) when focus leaves
    document.querySelectorAll('.am-toolbar [data-bs-toggle="dropdown"][data-bs-focusable="true"]').forEach(element => {
        var dropdownContainer = element.closest('.dropdown');
        dropdownContainer.addEventListener('focusout', function() {
            setTimeout(function() {
                if (!dropdownContainer.contains(document.activeElement) && element.dataset.over === 'false') {
                    tryCloseDropdown(element);
                }
            }, 200);
        });
    });

    setTimeout(() => {
        openLoginDropdown();
    }, 500);
});